// Scripts pour la Page d'accueil

import { A, O, pipe } from "@mobily/ts-belt";

import {
  ATTRIBUT_ARIA_HIDDEN,
  ATTRIBUT_CACHE,
  SELECTEUR_CONTENEUR_STORYTELLING,
  SELECTEUR_IMAGES_STORYTELLING,
} from "./constantes/dom.ts";
import { estEntreDeuxNombres } from "./lib/nombres.ts";
import { recupereEleOuLeve, recupereElesOuLeve } from "./lib/utils.ts";

const initialiseScrollStorytelling = (): void => {
  const E = {
    /** Le conteneur des images du storytelling. */
    CONTENEUR_STORYTELLING: recupereEleOuLeve<HTMLElement>(".storytelling__conteneur"),
    /** Les images du storytelling. */
    IMAGES_STORYTELLING: recupereElesOuLeve<HTMLDivElement>(SELECTEUR_IMAGES_STORYTELLING),
    /** Le bloc contenant le storytelling. */
    STORYTELLING: recupereEleOuLeve<HTMLElement>(SELECTEUR_CONTENEUR_STORYTELLING),
  };

  /** La hauteur d'une image du storytelling. */
  let hauteurImage = E.IMAGES_STORYTELLING.at(0)?.getBoundingClientRect().height ?? 0;
  /** La position du défilement (en pixels) du Conteneur des images du storytelling. */
  let positionDefilementConteneur = 0;

  /**
   * TODO
   * @param image
   * @param visible
   */
  const changeVisibiliteImage = (image: HTMLDivElement, visible: boolean) => {
    image.toggleAttribute(ATTRIBUT_CACHE, visible);
    image.toggleAttribute(ATTRIBUT_ARIA_HIDDEN, visible);
  };

  /**
   * TODO
   */
  const majDimensions = (): void => {
    hauteurImage = pipe(
      A.getBy(E.IMAGES_STORYTELLING, (i: HTMLDivElement) => !i.hasAttribute(ATTRIBUT_CACHE)),
      O.map((i: HTMLDivElement) => i.getBoundingClientRect().height),
      O.getWithDefault(0),
    );
    E.CONTENEUR_STORYTELLING.style.minHeight = `${String(hauteurImage * E.IMAGES_STORYTELLING.length + 61)}px`;
    E.CONTENEUR_STORYTELLING.style.maxHeight = `${String(hauteurImage * E.IMAGES_STORYTELLING.length + 61)}px`;
  };

  /**
   * TODO
   */
  const majImages = (): void => {
    // Met à jour la position du défilement dans le Conteneur
    positionDefilementConteneur = E.STORYTELLING.scrollTop;

    // Met à jour l'attribut de visibilité des images en fonction du défilement
    E.IMAGES_STORYTELLING.forEach((image: HTMLDivElement, index: number): void => {
      const debutYImage = hauteurImage * index;
      const finYImage = hauteurImage * (index + 1);

      changeVisibiliteImage(image, !estEntreDeuxNombres(positionDefilementConteneur, debutYImage, finYImage));
    });
  };

  // Initialise l'Observateur de Redimensionnement (ResizeObserver)
  new ResizeObserver((): void => {
    majDimensions();
    majImages();
  }).observe(E.STORYTELLING);

  // Initialise la mise à jour des images au défilement sur le Conteneur
  E.STORYTELLING.addEventListener("scroll", (): void => majImages());
};

document.addEventListener("DOMContentLoaded", (): void => {
  initialiseScrollStorytelling();
});
